import moment from 'moment';
import { groups } from './devdata';
import AppUsersClient from "../clients/AppUsersClient";

const resource = '/group';

export default {
  getById: (groupId) => AppUsersClient.get(`${resource}/${groupId}`),
  getForPeriod(startDate, endDate, teamFilter) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(`${resource}/?fromdate=${moment(startDate).format('YYYY-MM-DD')}&todate=${moment(endDate).format('YYYY-MM-DD')}&forteam=${(teamFilter ? teamFilter : '')}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  getAllForMyCalendar(){
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(`${resource}/getAllForMyCalendar`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  getAll() {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(`${resource}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  create(group) {
      return AppUsersClient.post(`${resource}`, group);
  },
  update(group) {
    return new Promise(function(resolve, reject) {        
      AppUsersClient
      .put(`${resource}`, group)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  async remove(groupId) {
    await AppUsersClient.put(`${resource}/remove/${groupId}`);
  },
  delete(groupId, updateTag) {
    return new Promise((resolve, reject) => {
      let index = groups.findIndex(q => q.id === groupId);
      if (index >= 0) {
        groups.splice(index, 1);
      }
      return resolve(groups);
    });
  },
  getGroupsForUser(id) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(`${resource}/getGroupsForUser/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  getUsersGorGroup(id) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(`${resource}/getUsersGorGroup/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  // delete(projectId, updateTag) {
  //   return new Promise(function(resolve, reject) {
  //     authService.acquireToken(['api://6b77f60e-8f2e-4d88-8f34-fb827da6f495/planning.manage']) //projects.manage
  //     .then(accessToken => {
  //       const headers = { 'Authorization': `Bearer ${accessToken}` };
  //       const options = {
  //         headers
  //       };
  //       axios
  //       .delete(`${constants.planningApiBasePath}/projects/${projectId}?updateTag=${updateTag}`, options)
  //         .then(response => {
  //           resolve(response);
  //         })
  //         .catch(error => {
  //           reject(error);
  //         });
  //     }).catch(error => {
  //       reject(error);
  //     });
  //   });
  // },
};
